(function () {
  if (!document.body || !document.body.classList.contains('page-saelg-elektronik')) return;
  if (document.body.classList.contains('page-saelg-brugt-computer')) return;

  var MARK = 'sep26-reusely-type';
  var sheet = null;
  var observer = null;
  var watched = null;

  var css = [
    '.card.section-card-container,',
    '.card.section-card-container .section-card-title,',
    '.card.section-card-container .section-card-text,',
    '.search-sell-input {',
    '  font-family: Figtree, var(--font-body-family), sans-serif !important;',
    '}',
    '.card.section-card-container {',
    '  border-radius: var(--radius-lg, 24px) !important;',
    '}',
    '.search-sell-input {',
    '  border-radius: 16px !important;',
    '}'
  ].join('\n');

  function host() {
    var root = document.getElementById('sep26-reusely');
    if (!root || root.id === 'pc-buyback-widget') return null;
    if (root.querySelector('#pc-buyback-widget')) return null;
    return root.querySelector('.buyback-widget');
  }

  function hasSheet(shadow) {
    if (!shadow || !shadow.adoptedStyleSheets) return false;
    var list = shadow.adoptedStyleSheets;
    for (var i = 0; i < list.length; i++) {
      if (list[i] === sheet || list[i][MARK]) return true;
    }
    return false;
  }

  function apply() {
    var el = host();
    var shadow = el && el.shadowRoot;
    if (!shadow || hasSheet(shadow)) return !!shadow && hasSheet(shadow);
    try {
      if (!sheet) {
        sheet = new CSSStyleSheet();
        sheet.replaceSync(css);
        sheet[MARK] = true;
      }
      var list = shadow.adoptedStyleSheets;
      var next = [];
      for (var i = 0; i < list.length; i++) next.push(list[i]);
      next.push(sheet);
      shadow.adoptedStyleSheets = next;
    } catch (e) {}
    return hasSheet(shadow);
  }

  function disconnect() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    watched = null;
  }

  function onChange() {
    var el = host();
    if (el && el !== watched) {
      if (observer) observer.disconnect();
      watched = el;
      observer = new MutationObserver(onChange);
      observer.observe(el, { attributes: true, childList: true });
    }
    if (apply()) disconnect();
  }

  if (apply()) return;
  onChange();
})();
